<template>
  <wt-dropdown-view
    v-if="story"
    class="wt-story-colors-and-fonts wt2-sg"
    ref="dropdown"
    type="right"
    :transientView="true"
    @opened="onOpened"
    @closed="onClosed"
  >
    <template slot="label">
      <wt-button
        :class="['change-style-button', open ? 'wt-button-active' : '']"
        type="transparent"
        :text="texts.videoStyle"
      >
        <template v-slot:suffix>
          <i
            :class="[
              'wticon',
              open ? 'wticon-chevron-up' : 'wticon-chevron-down',
              '-chevron',
            ]"
          />
        </template>
      </wt-button>
    </template>
    <template slot="view">
      <video-style
        :color-sets="story.colorSets"
        :selected-color-set="story.selectedColorSet"
        :original-color-set="story.originalColorSet"
        :recent-color-set-count="story.recentColorSetsCount"
        :recent-color-sets="story.recentColorSets"
        :fonts="story.fonts"
        :selected-fonts="story.selectedFonts"
        :original-fonts="story.originalFonts"
        :default-fonts="story.defaultFonts"
        :texts="texts"
        :css-vars="cssVars"
        @selected-color-set="setSelectedColorSet"
        @selected-font="SET_SELECTED_FONT"
        @add-recent-color-set="addRecentColorSet"
        @reset-video-style="RESET_VIDEO_STYLE"
        @track="track"
        @close="close"
      >
      </video-style>
    </template>
  </wt-dropdown-view>
</template>

<script>
import Vue from 'vue';
import VideoStyle from '@wochitnpm/video-style';
import { mapActions, mapState } from 'vuex';

export default Vue.extend({
  name: 'MastheadColorsAndFonts',

  components: {
    VideoStyle,
  },

  data() {
    return {
      open: false,
      cssVars: {
        '--button-radius': 0,
        '--dialog-footer-height': '50px',
      },
      texts: app.culture.videoStyle,
    };
  },

  computed: {
    ...mapState({
      story: (state) => state.story,
    }),
  },

  methods: {
    track(name, data) {
      console.log('track ', name, data);
    },
    onOpened() {
      this.open = true;
    },
    onClosed() {
      this.open = false;
    },
    close() {
      this.$refs.dropdown.close();
    },
    addRecentColorSet() {
      this.ADD_RECENT_COLOR_SET();
      this.close();
    },
    setSelectedColorSet(colorSet) {
      this.SET_SELECTED_COLOR_SET({
        colorSet,
        refreshPreview: true,
      });
    },
    ...mapActions([
      'SET_SELECTED_COLOR_SET',
      'SET_SELECTED_FONT',
      'ADD_RECENT_COLOR_SET',
      'RESET_VIDEO_STYLE',
    ]),
  },
});
</script>

<style lang="scss" scoped>
@import 'style_guide/_sg_variables.scss';
.wt-story-colors-and-fonts {
  height: 50px;
  --footer-padding: 0;
}
div.-storyboard-style {
  width: 375px;
}
button.change-style-button.wt-button {
  padding-left: 15px;
  padding-right: 15px;
  > span {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  .-chevron {
    font-size: 16px;
    margin-left: 15px;
    margin-right: 0;
  }
}

/deep/ button.primary:not(.-add) {
  height: 34px;
  border-radius: 3px;
  font-size: 14px;
  padding: 5px 15px;
}
</style>
